import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'

import axios from 'axios'
import VueAxios from 'vue-axios'

// Icons
import '../node_modules/@fortawesome/fontawesome-free/css/all.css'

//Loaders
import 'vue-loaders/dist/vue-loaders.css';
import VueLoaders from 'vue-loaders';

import SmartTable from 'vuejs-smart-table'

loadFonts()

createApp(App)
  .use(router)
  .use(vuetify)
    .use(VueAxios, axios)
    .use(VueLoaders)
    .use(SmartTable)
  .mount('#app')
